import I18n from './locale/pt';

export default I18n;